/**
 * Inputs: calendar day. Outputs: links into Compose with a fixed plan type.
 */

import { Link } from "react-router";

export type PlanKind = "transfer" | "excursion" | "free_time" | "idea";

const OPTIONS: { kind: PlanKind; label: string; hint: string }[] = [
  { kind: "transfer", label: "Transfer", hint: "Taxi, Grab, or van — booked or not" },
  { kind: "excursion", label: "Excursion or plan", hint: "Booked activity or timed plan" },
  { kind: "free_time", label: "Free time", hint: "A labelled block on the day" },
  { kind: "idea", label: "Idea", hint: "Not booked yet" },
];

export function AddPlanChooser({ day, backTo }: { day: string; backTo?: string }) {
  const base = `/journey/day/${day}/add`;
  return (
    <section className="add-plan-chooser" aria-label="Add to this day">
      <p className="muted">Pick what you are adding for {day}.</p>
      <div className="add-plan-grid">
        {OPTIONS.map((opt) => (
          <Link key={opt.kind} className="add-plan-tile" to={`${base}?kind=${opt.kind}`}>
            <span className="add-plan-label">{opt.label}</span>
            <span className="add-plan-hint">{opt.hint}</span>
          </Link>
        ))}
      </div>
      {backTo ? (
        <p style={{ marginTop: 12 }}>
          <Link className="btn-ghost" to={backTo}>Cancel</Link>
        </p>
      ) : null}
    </section>
  );
}
